import type { Helpers } from "./endpoints-shared";
import type { In, Out } from "./operations";
import type { PageRequest } from "./types";
export function posCountEndpoints({ get, post, put, paged }: Pick<Helpers, "get" | "post" | "put" | "paged">) {
  return {
    stockCounts: (page: PageRequest & { status?: "draft" | "posted" | "cancelled" } = {}) => get<Out<"pos_stock_counts">>("/pos/inventory/counts", paged(page, { status: page.status })),
    stockCount: (id: string) => get<Out<"pos_stock_count">>(`/pos/inventory/counts/${id}`),
    createStockCount: (body: In<"pos_stock_count_create">) => post<Out<"pos_stock_count_create">>("/pos/inventory/counts", body),
    saveStockCount: (id: string, body: In<"pos_stock_count_save">) => put<Out<"pos_stock_count_save">>(`/pos/inventory/counts/${id}`, body),
    postStockCount: (id: string, body: In<"pos_post_stock_count">) => post<Out<"pos_post_stock_count">>(`/pos/inventory/counts/${id}/post`, body),
    restartStockCount: (id: string, body: In<"pos_stock_count_restart">) => post<Out<"pos_stock_count_restart">>(`/pos/inventory/counts/${id}/restart`, body),
    cancelStockCount: (id: string, body: In<"pos_stock_count_cancel">) => post<Out<"pos_stock_count_cancel">>(`/pos/inventory/counts/${id}/cancel`, body),
  };
}
